import { defineStore } from "pinia";

import { useEntityStore } from "@/shared";

import { getFreeInventoriesByRent } from "../api/getFreeInventoriesByRent";

export const useFreeInventoriesStore = defineStore("freeInventories", () => {
    const {
        isManyLoading,
        manyError,
        listData,
        meta,
        permissions,
        fetchMany,
        setManyLoading,
    } = useEntityStore({
        getEntities: getFreeInventoriesByRent,
    });

    return {
        listData,
        isManyLoading,
        manyError,
        meta,
        permissions,
        fetchMany,
        setManyLoading,
    };
});
